import React, { useContext, useLayoutEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Transition, TransitionGroup } from 'react-transition-group'
import { gsap, ScrollSmoother, ScrollTrigger } from 'helpers/gsap'
import ThemeProvider, { ThemeContext } from '../../helpers/ThemeProvider'
// import HeaderTransition from '../ui/header-transition'
import Header from 'components/header'
import Footer from 'components/footer'
import Menu from '../header/menu'
import NavigationNext from '../ui/navigation-next'
// import ClosingBanner from '../ui/closing-banner'
// import TownhousesBanner from '../ui/townhouses-banner'
import CookiesBanner from '../ui/cookies-banner'
import ClosingBannerHeader from '../ui/closing-banner-header'
import RightPart from '../header/right-part'

import 'helpers/fonts.css'
import GlobalStyle from 'helpers/globalStyles'
import { LayoutWrapper, PageWrapper, ContentWrapper } from './index.styled'
// import useWindowSize from '../../helpers/useWindowSize'

const LayoutContent = ({ children, location, className }) => {
  return (
    <div className={className}>
      <TransitionGroup component={null}>
        <Transition key={location.pathname} timeout={{ enter: 100, exit: 0 }}>
          {(status) => (
            <div className={`page ${status}`}>
              {/*  <HeaderTransition status={status}> */}
              <LayoutWrapper>{children}</LayoutWrapper>
              {/*  </HeaderTransition> */}
            </div>
          )}
        </Transition>
      </TransitionGroup>
    </div>
  )
}

const LayoutGsapWrapper = ({ children, location }) => {
  const refWrapper = useRef(null)
  const isHomePage = location.pathname === '/' && location.hash !== '#building'
  // let tr
  // let prevScrollPos

  const { scrollSmoother } = useContext(ThemeContext)

  // const { isMobile } = useWindowSize()

  useLayoutEffect(() => {
    // const header = document.querySelector('#rightPart')
    // prevScrollPos = window?.pageYOffset

    const gsapContext = gsap.context(() => {
      scrollSmoother.current = ScrollSmoother.create({
        content: '.content',
        wrapper: '.wrapper',
        smooth: 2,
        effects: true,
        normalizeScroll: { allowNestedScroll: true }
      })
      // pin
      gsap.utils.toArray('.pin').forEach(function (container) {
        ScrollTrigger.create({
          trigger: container,
          pinSpacing: false,
          pin: true,
          start: 'bottom bottom',
          anticipatePin: 1
        })
      })
      // fadeIn
      gsap.utils.toArray('.fadeIn').forEach(function (container) {
        ScrollTrigger.create({
          trigger: container,
          start: 'top 90%',
          end: '+=1000%',
          toggleClass: {
            targets: container,
            className: 'visible',
            toggle: 'add'
          }
          // once: true,
        })
      })
      // parallax
      gsap.utils.toArray('.parallax').forEach(function (container) {
        scrollSmoother.current.effects(container.querySelector('.content'), {
          speed: 0.5
        })
      })
    }, refWrapper)

    // document.addEventListener('scroll', onScroll)

    return () => gsapContext.revert()
  }, [children, scrollSmoother])

  /*  const onScroll = (e) => {
    const header = document.querySelector('#rightPart')

    const delta = window.pageYOffset

    const startPoint = document.getElementById('startPoint')
    const hh = header?.clientHeight || 0

    const currentScrollPos = window.pageYOffset

    if (delta - startPoint.offsetTop > 0) {
      if (delta - startPoint.offsetTop <= hh) {
        header.style.top = `-${delta - startPoint.offsetTop}px`
      } else {
        header.style.top = `-${hh}px`
      }

      if (currentScrollPos <= prevScrollPos) {
        header.style.top = 0
      }
      prevScrollPos = currentScrollPos
    }
  } */

  return (
    <PageWrapper>
      {/* {isHomePage && isFirstLoad && (
        <MainIntro setIsFirstLoad={setIsFirstLoad} />
      )} */}
      <CookiesBanner />
      <ClosingBannerHeader isHome={isHomePage} />
      {/* {location.pathname === '/penthouses/' && <ClosingBanner />}
      {location.pathname !== '/penthouses/' && <TownhousesBanner />} */}
      {/* <TownhousesBanner /> */}
      <Header
        isHomePage={isHomePage}
        className={[isHomePage ? 'home homeStart' : '']}
        id='header'
      />
      <RightPart className={`${isHomePage ? 'home homeStart' : ''}`} />
      <Menu />
      <ContentWrapper className='wrapper' ref={refWrapper}>
        {/* <Header
          isHomePage={isHomePage}
          className={[isHomePage ? 'home homeStart' : '']}
          id='header'
        /> */}
        <LayoutContent location={location} className='content'>
          {children}
          <NavigationNext />
          <Footer />
        </LayoutContent>
      </ContentWrapper>
    </PageWrapper>
  )
}

const Layout = ({ children, location }) => {
  return (
    <ThemeProvider location={location}>
      <GlobalStyle />
      <LayoutGsapWrapper location={location}>
        {children}
      </LayoutGsapWrapper>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired
}

export default Layout
